module.exports = __webpack_public_path__ + "img/oak-mask.b8d879a6.png";